import React from "react";
import "./applicationForm.css";

const ApplicationForm = () => {
  return (
    <div className="application-form-container">
      <h1 className="title">Application Form</h1>

      <div className="application-card">
        <h2 className="subtitle">
          Begin your journey with us by submitting your application.
        </h2>

        <div className="application-form-buttons">
          <button
            className="application-btn"
            onClick={() =>
              window.open(
                "https://www.digialm.com//EForms/configuredHtml/176/69589/Registration.html",
                "_blank",
              )
            }
          >
            New User
          </button>

          <button
            className="application-btn secondary"
            onClick={() =>
              window.open(
                "https://www.digialm.com/EForms/configuredHtml/176/69589/login.html",
                "_blank",
              )
            }
          >
            Existing User
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApplicationForm;
